// Module
var code = `<div id="stageWrapper">
    <div id="stage"></div>
    <div class="previewNotification">Preview of {{scene.name}}</div>
</div>`;
// Exports
export default code;